import React from 'react';

/**
 * «Готово» поверх экрана, пока на телефоне открыта клавиатура.
 *
 * В режиме клавиатуры на экране остаётся одно поле (index.css, .kbd-hide), и
 * выйти из правки можно было только тапом мимо текста — владелец 28.09.2026:
 * «то, что нужно кликнуть с края страницы, вовсе не очевидно». Кнопка снимает
 * фокус с поля: клавиатура закрывается, useKeyboard возвращает обычный вид.
 * Стоит сверху справа: снизу у чата кнопка «Отправить», её не перекрываем.
 */
export default function KeyboardDoneButton() {
  return (
    <button
      type="button"
      data-testid="kbd-done"
      // pointerdown с preventDefault: иначе фокус уходит на саму кнопку раньше
      // клика, и на iOS клавиатура успевает дёрнуться.
      onPointerDown={(e) => e.preventDefault()}
      onClick={() => { if (document.activeElement) document.activeElement.blur(); }}
      className="absolute top-2 right-3 z-50 h-9 rounded-full bg-paper-ink px-4 text-[15px] font-semibold text-white shadow-[0_4px_14px_rgba(0,0,0,.18)]"
    >
      Готово
    </button>
  );
}
